$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import {Navigation,Pagination,Autoplay,} from 'swiper/modules';




gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {

    $(document).ready(function () {
        // Animation sur le h2 (effet surligné)
        $(".title h2").each(function (index, element) {
            gsap.fromTo(
                element, // Cible chaque élément `h2` individuellement
                { "--after-width": "0%" }, // Départ
                {
                    "--after-width": "100%", // Fin
                    duration: 1,
                    scrollTrigger: {
                        trigger: element, // Déclencheur spécifique à cet élément
                        start: "top 80%", // Début de l'animation
                        end: "bottom 60%", // Fin de l'animation
                        scrub: true, // Animation fluide
                        // markers: true, // Débogage avec marqueurs (optionnel)
                    },
                }
            );
        });

        gsap.fromTo(
            ".title_hover", // Cible uniquement l'élément parent
            { "--after-width": "0%" }, // Départ
            {
                "--after-width": "100%", // Fin
                duration: 1,
                scrollTrigger: {
                    trigger: ".title_hover", // L'élément déclencheur
                    start: "top 80%", // Début de l'animation
                    end: "bottom 60%", // Fin de l'animation
                    scrub: true, // Animation fluide
                    //markers:true,
                },
            }
        );

        function activateLottieAnimations() {
            // Sélectionner tous les lecteurs Lottie dans la section
            $(".map  dotlottie-player").each(function () {
            const player = this; // Référence au lecteur Lottie actuel

            // Créer une animation GSAP liée à ScrollTrigger
            ScrollTrigger.create({
                trigger: player, // Élément déclencheur (le lecteur Lottie)
                start: "top 70%", // Commence à 70% de la hauteur de la fenêtre
                onEnter: function () {
                player.play(); // Joue l'animation lorsque l'élément entre dans le viewport
                },
                onLeaveBack: function () {
                player.stop(); // Stoppe l'animation lorsque l'élément sort du viewport vers le haut
                },
            });
            });
        }

        // Activer les animations après le chargement du DOM
        activateLottieAnimations();




    });

      


    // --- SHOWHIDE NAVBAR ---

    var didScroll;
    var lastScrollTop = 0;
    var delta = 120;
    var navbarHeight = 110;
    $(window).scroll(function () {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 350);
    function hasScrolled() {
        var st = $(this).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight) {
            $('.nav-sticky').addClass('nav-up');
        } else {
            if (st + $(window).height() < $(document).height()) {
                $('.nav-sticky').removeClass('nav-up');
            }
        }
        lastScrollTop = st;
    }
    
    // --- NAV ---

    
    $(".nav-burger").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    }); 
    
    $(".nav-active ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });
    
    $(".page-single article .gallery br").remove();  

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    $(document.body).trigger('wc_fragment_refresh');


     

     /*-------- Swiper annimation header ---------*/

     var mySwiper = new Swiper(".navSwiper", {
        modules: [Autoplay],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,

        autoplay: {
            delay: 3000,
        },
       
    });

     // === COUNT UP ===
     const countUpElements = document.querySelectorAll('.count-up');
     countUpElements.forEach(element => {
         const targetValue = parseInt(element.textContent, 10);
         element.textContent = '0';
         const counter = { value: 0 };
         ScrollTrigger.create({
             trigger: element,
             start: 'top 95%',
             onEnter: () => gsap.to(counter, {
                 value: targetValue,
                 duration: 1.5,
                 onUpdate: () => {
                     element.textContent = Math.round(counter.value);
                 },
                 ease: "power1.inOut"
             }),
             //markers: true,
         });
   });
   
   
   function createScrollTriggerAnimation(element) {
    gsap.to(element, {
      scrollTrigger: {
        trigger: element, // Chaque élément agit comme son propre déclencheur
        start: "top 80%", // Débute quand le haut de l'élément arrive à 80% de la hauteur de la fenêtre
        toggleActions: "play none none none", // Joue uniquement une fois
      },
      y: 0,              // Animation : translateY à 0
      duration: 1,       // Durée de 1 seconde
      autoAlpha: 1,      // Combine opacity: 1 et visibility: visible
      zIndex: 50,
    });
  }
  
  function initGSAPAnimations() {
    // Sélectionner tous les éléments .anim et créer une animation pour chacun
    document.querySelectorAll(".anim").forEach((element) => {
      createScrollTriggerAnimation(element);
    });
  }
  
  initGSAPAnimations();


    
});



    
    

